<template>
  <div
    :style="'min-height:' + height +  'px;'"
    :class="
      'full-width q-px-md column justify-' + justify + ' items-' + verticalAlign +
        (bgColor ? ' bg-' + bgColor : '') +
        (textColor ? ' text-' + textColor : '') +
        (divider ? ' d-bottom-border' : '')
    "
  >
    <div v-if="title !== null" :style="'line-height:1.2em;font-size:' + fontSize" :class="'ellipsis ' + textClass">
      {{ formatText(title, formatter) }}
    </div>
    <div v-if="caption !== null" :style="'font-size:' + captionFontSize" :class="'ellipsis ' + captionTextClass">
      {{ formatText(caption, captionFormatter) }}
    </div>
  </div>
</template>

<script>

import mixin from './d-card-mixins'

export default {
  name:'DCTitlebar',
  mixins: [mixin],
  props: {
    height: {
      type: Number,
      default: 30
    },
    fontSize: {
      type: String,
      default:'1em'
    },
    justify: {
      type: String,
      default: 'center'
    },
    verticalAlign: {
      type: String,
      default: 'center'
    },
    textClass: {
      type: String,
      default: ''
    },
    textColor: {
      type: String,
      default: null
    },
    bgColor: {
      type: String,
      default: null
    },
    divider: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    formatter: {
      type: String,
      default: null
    },
    caption: {
      type: String,
      default: null
    },
    captionFontSize: {
      type: String,
      default: '.9em'
    },
    captionTextClass: {
      type: String,
      default: ''
    },
    captionFormatter: {
      type: String,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped>
@import url('./d-card.scss');
</style>

